import { differenceInHours, differenceInMinutes, max, min } from "date-fns";

export default function validate(data) {
    let errors = {};

    let sender_errors = {}

    if (!data.delivery?.sender?.fio) {
      sender_errors.fio = 'FIO_error';
    }
  
    if (!data.delivery?.sender?.contract_face) {
      sender_errors.contract_face = 'contract_face_error';
    }
  
    let sender_phones_errors = {}
  
    data.delivery?.sender?.phones?.forEach((phone, index) => {
      let phone_errors = {}
  
      if (!phone.number) {
        phone_errors.number = 'phone_error';
      }
  
      if (Object.keys(phone_errors).length > 0) {
        sender_phones_errors[index] = phone_errors
      }
    })
  
    if (Object.keys(sender_phones_errors).length > 0) {
      sender_errors.phones = sender_phones_errors;
    }
    
    if (Object.keys(sender_errors).length > 0) {
      errors.sender = sender_errors;
    }
  
    // Получатель
  
    let recipient_errors = {}
  
    if (!data.delivery?.recipient?.fio) {
      recipient_errors.fio = 'FIO_error';
    }
  
    if (!data.delivery?.recipient?.contract_face) {
      recipient_errors.contract_face = 'contract_face_error';
    }
  
    let recipient_phones_errors = {}
  
    data.delivery?.recipient?.phones?.forEach((phone, index) => {
      let phone_errors = {}
  
      if (!phone.number) {
        phone_errors.number = 'phone_error';
      }
  
      if (Object.keys(phone_errors).length > 0) {
        recipient_phones_errors[index] = phone_errors
      }
    })
  
    if (Object.keys(recipient_phones_errors).length > 0) {
      recipient_errors.phones = recipient_phones_errors;
    }
    
    if (Object.keys(recipient_errors).length > 0) {
      errors.recipient = recipient_errors;
    }
  
    if ( (data.selected_mode == 1 || data.selected_mode == 2) && !data.addressFrom) {
      errors.addressFrom = 'from_address_error';
    }
  
    if ( (data.selected_mode == 1 || data.selected_mode == 3) && !data.addressTo) {
      errors.addressTo = 'to_address_error';
    }
  
    if ( (data.selected_mode == 2 || data.selected_mode == 4) && !data.pvzTo) {
      errors.pvzTo = 'to_pvz_address_error';
    }
  
    if (data.selected_mode != 1 && data.selected_mode != 2) {
      console.log(errors)
      return errors
    }
  
    if (!data.delivery_date_from) {
      errors.delivery_date_from = 'courier_date_error';
    }
  
    if (!data.delivery_time_from || !data.delivery_time_to) {
      errors.delivery_time_from = 'courier_time_error';
    } else {
      if (data.delivery_time_from >= data.delivery_time_to) {
        errors.delivery_time_from = 'courier_time_error';
      }
  
      let couirer_window = differenceInMinutes(data.delivery_time_to, data.delivery_time_from);
  
      if (couirer_window < 180) {
        errors.delivery_time_from = 'courier_time_interval_error';
      }
  
      if (data.break_time_from && data.break_time_to) {
        let effectiveBreakFrom = max([data.delivery_time_from, data.break_time_from]);
        let effectiveBreakTo = min([data.delivery_time_to, data.break_time_to]);
  
        let breakDuration = differenceInMinutes(effectiveBreakTo, effectiveBreakFrom);
  
        console.log(breakDuration)
        console.log(effectiveBreakFrom)
        console.log(effectiveBreakTo)
        
        if (couirer_window - breakDuration < 180) {
          errors.delivery_time_from = 'courier_time_interval_error';
        }
      }
    }

    return errors
}